import React from "react";
import { useSelector } from "react-redux";
import { Controller } from "react-hook-form";
import Dropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import ToggleableButton from "../../../../components/toggleableButton/toggleableButton";

export const Dashboard = ({
  control,
  isEditMode,
  defaultRevenueCategoriesOnTotalRevenueModule
}) => {
  const { defaultDashboardModules } = useSelector((state) => state.organizations.commonSettings);

  return (
    <>
      <div className="admin-organizations__section">
        <div className="admin-organizations__dropdown">
          <p>Default dashboard modules</p>
          <Controller
            control={control}
            name="default_dashboard_modules"
            render={({ field: { onChange, value } }) => {
              return (
                <Dropdown
                  valueKey="name"
                  height={275}
                  haveOnSelectChange
                  includeSelectAll
                  enableOnly
                  options={defaultDashboardModules}
                  selectedFilters={value ?? []}
                  numberDisplayed={0}
                  onSelectChange={(data) => onChange(data)}
                />
              );
            }}
          />
        </div>

        {isEditMode ? (
          <div className="admin-organizations__dropdown">
            <p>Default revenue categories on total revenue module</p>
            <Controller
              control={control}
              name="default_revenue_type_ids"
              render={({ field: { onChange, value } }) => {
                return (
                  <Dropdown
                    valueKey="name"
                    height={275}
                    haveOnSelectChange
                    includeSelectAll
                    enableOnly
                    options={defaultRevenueCategoriesOnTotalRevenueModule}
                    selectedFilters={value ?? []}
                    numberDisplayed={0}
                    onSelectChange={(data) => onChange(data)}
                  />
                );
              }}
            />
          </div>
        ) : (
          <div className="admin-organizations__empty" />
        )}
      </div>

      <div className="admin-organizations__section">
        <div className="switch">
          <p className="switch__title">Secondary rc level</p>
          <Controller
            control={control}
            name="use_secondary_revenue_categories"
            render={({ field: { onChange, value } }) => {
              return (
                <div className={`switch__content ${value ? "switch__content--active" : ""}`}>
                  <ToggleableButton
                    isRadio
                    title="useSecondaryRevenueCategories"
                    isActive={value}
                    onClick={(isActive) => onChange(isActive)}
                  />
                </div>
              );
            }}
          />
        </div>
      </div>
    </>
  );
};
